export const stats = [
  { value: '36', label: 'Trading partners' },
];

export const locations = [
  { name: 'UAE', flag: '🇦🇪' },
  { name: 'UK', flag: '🇬🇧' },
  { name: 'SINGAPORE', flag: '🇸🇬' },
  { name: 'USA', flag: '🇺🇸' },
  { name: 'BELGIUM', flag: '🇧🇪' },
  { name: 'SWITZERLAND', flag: '🇨🇭' },
];

export const services = [
  {
    id: 'trading',
    label: 'TRADING',
    title: 'Physical Energy Trading',
    description:
      'NRG Trading is an independent physical energy trader with a proven track record of delivering value across global energy markets. Our trading operations span crude oil and refined products enabling us to serve a diverse range of customers across the world.',
    image: 'https://public.readdy.ai/ai/img_res/42bf011d5aa417e3ab719befe56f017e.jpg',
  },
];

export const newsItems = [
  {
    id: 1,
    category: 'SHIPPING',
    date: '15 FEBRUARY 2025',
    title: 'NRG Trading Revamps Shipping Arm with New Partnership',
    excerpt:
      'NRG Trading is restructuring and strengthening its shipping and freight operations under a new strategic partnership with experienced freight executives, aiming to optimize logistics and most recently Marine Shipping.',
    image: 'https://readdy.ai/api/search-image?query=large%20red%20oil%20cargo%20ship%20sailing%20on%20open%20ocean%20under%20dramatic%20cloudy%20sky%2C%20maritime%20shipping%20industrial%20vessel%2C%20aerial%20perspective%2C%20professional%20photography%20wide%20angle&width=600&height=400&seq=news1&orientation=landscape',
  },
  {
    id: 2,
    category: 'FINANCING',
    date: '11 FEBRUARY 2025',
    title: 'NRG Trading Secures First South Sudan Cargo and Advances Repayment Agreement',
    excerpt:
      'NRG Trading is pleased to confirm the lifting of its first cargo under renewed arrangements for the supply of petroleum products to the Republic of South Sudan.',
    image: 'https://readdy.ai/api/search-image?query=oil%20tanker%20loading%20at%20industrial%20port%20facility%20with%20cranes%20and%20pipelines%2C%20petroleum%20cargo%20loading%20operations%2C%20maritime%20logistics%20terminal%2C%20professional%20photography%20blue%20sky&width=600&height=400&seq=news2&orientation=landscape',
  },
  {
    id: 3,
    category: 'CASE STUDY',
    date: '28 JANUARY 2025',
    title: 'Compliance at NRG Trading',
    excerpt:
      'At NRG Trading, our compliance framework is built on integrity, transparency and accountability. We are committed to the highest standards of ethical business conduct across all our global operations.',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20meeting%20in%20modern%20corporate%20office%20with%20diverse%20team%20reviewing%20documents%2C%20compliance%20and%20governance%20energy%20company%20boardroom%2C%20clean%20interior%20natural%20light&width=600&height=400&seq=news3&orientation=landscape',
  },
];

export const keyDocuments = [
  { title: 'NRG Trading Company Profile 2025', icon: 'ri-file-pdf-line' },
  { title: 'NRG Trading Company Profile 2024', icon: 'ri-file-pdf-line' },
  { title: 'Code of Conduct', icon: 'ri-file-text-line' },
];

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Our Business', href: '#services' },
  { label: 'Sustainability', href: '#sustainability' },
  { label: 'Contact Us', href: '#contact' },
];

export const footerLinks = {
  company: [
    { label: 'Home', href: '#home' },
    { label: 'About us', href: '#about' },
    { label: 'Contact', href: '#contact' },
  ],
  business: [
    { label: 'Trading', href: '#' },
  ],
  sustainability: [
    { label: 'Our Approach', href: '#' },
  ],
  newsroom: [
    { label: 'Latest News', href: '#news' },
    { label: 'Press Releases', href: '#' },
    { label: 'Media Kit', href: '#' },
    { label: 'Careers', href: '#careers' },
  ],
  legal: [],
};
